import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import './pages/app-home';
import './styles/global.css';

@customElement('app-index')
export class AppIndex extends LitElement {
  static styles = css`
    :host {
      display: block;
      min-height: 100vh;
    }

    main {
      min-height: 100vh;
    }
  `;

  render() {
    return html`
      <main>
        <app-home></app-home>
      </main>
    `;
  }
}
